<template>
  <div class="bm4000-module">
    <el-form :label-width="isEnglish ? '160px' : '100px'" size="mini">
      <el-form-item :label="'设备编号:' | translateTo(i18nPath)">
        <el-row>{{ deviceInfo.sn }}</el-row>
      </el-form-item>
      <el-form-item :label="'设备名称:' | translateTo(i18nPath)">
        <el-row>{{ deviceInfo.name }}</el-row>
      </el-form-item>
      <el-form-item :label="'当前状态:' | translateTo(i18nPath)">
        <LineState :state="deviceInfo.state" />
        <span>{{ state | translateTo(i18nPath) }}</span>
      </el-form-item>
    </el-form>
    <div>
      <el-table :data="tableData" class="home-table" size="mini" border>
        <el-table-column v-for="v in tableColumn" :key="v.prop" :prop="v.prop" align="center">
          <template #header>
            <span style="white-space: pre-line; word-break: break-word">
              {{ v.label | translateTo(i18nPath) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="box-echarts">
      <v-chart :options="bioOptions1" :autoresize="true"></v-chart>
    </div>
    <div class="box-echarts">
      <v-chart :options="bioOptions2" :autoresize="true"></v-chart>
    </div>
  </div>
</template>

<script>
import { bm4000Line } from '@/echartOption/bm4000';
import LineState from '@/components/line-state';

export default {
  components: {
    LineState
  },
  props: {
    deviceInfo: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['deviceDetail'],
  data() {
    return {
      i18nPath: 'device',
      alarmState: 0,
      tableData: [
        // 表格数据
        { parOrAll: '-', bioOrAll: '-', bioConcentration: '-' }
      ],
      tableColumn: [
        { label: '总气溶胶粒子数\n(个/秒)', prop: 'parOrAll' },
        { label: '总荧光粒子数\n(个/秒)', prop: 'bioOrAll' },
        { label: '生物粒子浓度\n(个/升)', prop: 'bioConcentration' }
      ],
      alarmStateDict: {
        0: '正常',
        1: '生物报警',
        2: '烟雾报警',
        3: '生物警告'
      }
    };
  },
  computed: {
    state() {
      // 状态
      if (this.deviceInfo.state === undefined || this.deviceInfo.state === -1) {
        return '离线';
      } else if (this.deviceInfo.state === 71) {
        return '故障';
      } else {
        return this.alarmStateDict[this.alarmState];
      }
    },
    bioOptions1() {
      return bm4000Line({
        color: ['#5b88ff', '#7b6af1'],
        title: {
          text: this.$t('荧光气溶胶时间曲线'),
          top: 5,
          left: 'center',
          textStyle: {
            color: '#04a4bc'
          }
        },
        legend: {
          bottom: 5,
          top: 'bottom',
          left: 'center'
        },
        yAxis: {
          name: this.$t('个升'),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#172749'
            }
          }
        },
        series: [
          {
            showSymbol: false,
            name: this.$t('气溶胶荧光背景'),
            data: []
          },
          {
            showSymbol: false,
            name: this.$t('荧光粒子总数'),
            data: []
          }
        ]
      });
    },
    bioOptions2() {
      return bm4000Line({
        color: ['#6dddf1', '#f16cec'],
        title: {
          text: this.$t('气溶胶粒子总数时间曲线'),
          top: 5,
          left: 'center',
          textStyle: {
            color: '#04a4bc'
          }
        },
        legend: {
          bottom: 5,
          top: 'bottom',
          left: 'center'
        },
        yAxis: {
          name: this.$t('个升'),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#172749'
            }
          }
        },
        series: [
          {
            showSymbol: false,
            name: this.$t('气溶胶粒子总数'),
            data: []
          },
          {
            showSymbol: false,
            name: this.$t('噪声本底'),
            data: []
          }
        ]
      });
    }
  },
  watch: {
    deviceDetail: {
      handler(n) {
        let newVal = n.newVal;
        if (newVal && newVal.sn === this.deviceInfo.sn) {
          const { beginTime } = newVal;
          const {
            bioBground,
            bioAll,
            parAll,
            noiseBground,
            parOrAll,
            bioOrAll,
            bioConcentration,
            alarmState
          } = newVal.mods.bioMod;
          this.tableData[0]['parOrAll'] = parOrAll;
          this.tableData[0]['bioOrAll'] = bioOrAll;
          this.tableData[0]['bioConcentration'] = bioConcentration;
          if (this.bioOptions1.series[0].data.length > 59) {
            this.bioOptions1.series[0].data.shift();
            this.bioOptions1.series[1].data.shift();
            this.bioOptions2.series[0].data.shift();
            this.bioOptions2.series[1].data.shift();
          }
          this.bioOptions1.series[0].data.push([beginTime, bioBground]);
          this.bioOptions1.series[1].data.push([beginTime, bioAll]);
          this.bioOptions2.series[0].data.push([beginTime, parAll]);
          this.bioOptions2.series[1].data.push([beginTime, noiseBground]);
          this.alarmState = alarmState;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.bm4000-module {
  height: 100%;
  box-sizing: border-box;
  background-color: $bg-color;
  box-shadow: 0 0 2px 2px $bg-color;
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .el-form-item__label {
    font-weight: bold;
  }
  .box-echarts {
    width: 100%;
    height: calc((100% - 230px) / 2);
    overflow: hidden;
  }
  .bottom-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .dialog-echarts {
    height: 500px;
  }
  .search-echarts {
    height: 500px;
    width: 100%;
  }
  .home-table {
    font-size: 15px;
  }
}
</style>
